<template>
  <div class="portal-page">
    <!-- Animated Floating Blobs for Rich Aesthetics -->
    <div class="bg-blob blob-indigo"></div>
    <div class="bg-blob blob-rose"></div>
    <div class="bg-blob blob-teal"></div>

    <div class="portal-card">
      <div class="portal-topbar">
        <template v-if="loggedIn">
          <div class="user-meta animate__animated animate__fadeIn">
            <el-tag v-if="currentUser?.school" size="default" type="success" effect="light" class="school-tag">
              🏫 {{ currentUser.school }}
            </el-tag>
            <el-tag size="default" type="info" effect="plain" class="username-tag">
              👤 {{ currentUser?.username || '已登录用户' }}
            </el-tag>
            <el-button type="danger" plain size="small" @click="handleLogout" class="logout-btn">
              退出登录
            </el-button>
          </div>
        </template>
        <template v-else>
          <div class="auth-links animate__animated animate__fadeIn">
            <el-button type="primary" size="default" @click="goToLogin" class="auth-btn">登录</el-button>
            <el-button type="default" size="default" @click="goToRegister" class="auth-btn">注册新账号</el-button>
          </div>
        </template>
      </div>

      <div class="portal-header">
        <h1 class="portal-title">
          <span class="brand-love">爱教务</span><span class="brand-sub">智能教务系统</span>
        </h1>
        <p class="portal-subtitle">请选择您需要进入的专业业务子系统，开启高效的教学管理体验</p>
      </div>

      <div class="portal-grid">
        <!-- Card 1: Scheduling -->
        <div class="entry-card scheduling-theme" @click="goToScheduling">
          <div class="card-inner">
            <div class="theme-banner"></div>
            <div class="card-content">
              <div class="entry-title-row">
                <div class="icon-wrapper">
                  <el-icon><Calendar /></el-icon>
                </div>
                <span>排监考系统</span>
              </div>
              <p class="entry-desc">智能化监考智能分配，包含学期管理、教师数据库、不监考规则、年级分组及智能算法自动排程系统。</p>
              <div class="action-footer">
                <el-button type="primary" class="enter-btn" @click.stop="goToScheduling">
                  进入排监考 <el-icon class="btn-arrow"><Right /></el-icon>
                </el-button>
              </div>
            </div>
          </div>
        </div>

        <!-- Card 2: Grade Analysis -->
        <div class="entry-card analysis-theme" @click="goToAnalysis">
          <div class="card-inner">
            <div class="theme-banner"></div>
            <div class="card-content">
              <div class="entry-title-row">
                <div class="icon-wrapper">
                  <el-icon><DataAnalysis /></el-icon>
                </div>
                <span>成绩分析系统</span>
              </div>
              <p class="entry-desc">支持班级老师绑定、成绩录入、三/五门学科自定义折折算、班级学科综合排名与数据可视化看板。</p>
              <div class="action-footer">
                <el-button type="success" class="enter-btn" @click.stop="goToAnalysis">
                  进入成绩分析 <el-icon class="btn-arrow"><Right /></el-icon>
                </el-button>
              </div>
            </div>
          </div>
        </div>

        <!-- Card 3: Class Division -->
        <div class="entry-card division-theme" @click="goToDivision">
          <div class="card-inner">
            <div class="theme-banner"></div>
            <div class="card-content">
              <div class="entry-title-row">
                <div class="icon-wrapper">
                  <el-icon><Operation /></el-icon>
                </div>
                <span>智能分班系统</span>
              </div>
              <p class="entry-desc">双阶段智能分班，满足预设分配、排除班级、组合绑定与互斥打散规则，支持微调对换及全景统计看板。</p>
              <div class="action-footer">
                <el-button type="danger" class="enter-btn" style="background: #ec4899; color: white;" @click.stop="goToDivision">
                  进入智能分班 <el-icon class="btn-arrow"><Right /></el-icon>
                </el-button>
              </div>
            </div>
          </div>
        </div>

        <!-- Card 5: Course Scheduling -->
        <div class="entry-card course-schedule-theme" @click="goToCourseScheduling">
          <div class="card-inner">
            <div class="theme-banner"></div>
            <div class="card-content">
              <div class="entry-title-row">
                <div class="icon-wrapper">
                  <el-icon><Grid /></el-icon>
                </div>
                <span>智能排课系统</span>
              </div>
              <p class="entry-desc">全能智能课程表编排，支持合班课、单双周半节课、固定课锁，内置教师与科目防冲突日课时平衡求解引擎。</p>
              <div class="action-footer">
                <el-button type="primary" class="enter-btn" style="background: #8b5cf6; color: white;" @click.stop="goToCourseScheduling">
                  进入智能排课 <el-icon class="btn-arrow"><Right /></el-icon>
                </el-button>
              </div>
            </div>
          </div>
        </div>

        <!-- Card: Score Query -->
        <div class="entry-card score-query-theme" @click="goToScoreQuery">
          <div class="card-inner">
            <div class="theme-banner"></div>
            <div class="card-content">
              <div class="entry-title-row">
                <div class="icon-wrapper">
                  <el-icon><Search /></el-icon>
                </div>
                <span>成绩查询发布</span>
              </div>
              <p class="entry-desc">将成绩 Excel 表格上传后，自动生成专属链接，家长和学生可免登录通过姓名、学号或身份证号精准查询个人成绩。</p>
              <div class="action-footer">
                <el-button type="primary" class="enter-btn" style="background: #0ea5e9; color: white;" @click.stop="goToScoreQuery">
                  进入成绩查询 <el-icon class="btn-arrow"><Right /></el-icon>
                </el-button>
              </div>
            </div>
          </div>
        </div>

        <!-- Card 6: Exam Clock -->
        <div class="entry-card clock-theme" @click="goToClock">
          <div class="card-inner">
            <div class="theme-banner"></div>
            <div class="card-content">
              <div class="entry-title-row">
                <div class="icon-wrapper">
                  <el-icon><Clock /></el-icon>
                </div>
                <span>监考时钟大屏</span>
              </div>
              <p class="entry-desc">专为教室/考场大屏显示设计。提供高对比度计时、百分比进度条、考勤登记及网页铃声提示，可免登录快速配置使用。</p>
              <div class="action-footer">
                <el-button type="warning" class="enter-btn" style="background: #ea580c; color: white;" @click.stop="goToClock">
                  免登录使用 <el-icon class="btn-arrow"><Right /></el-icon>
                </el-button>
              </div>
            </div>
          </div>
        </div>

        <!-- Card 4: Admin (Conditional) -->
        <div v-if="isAdminUser" class="entry-card admin-theme" @click="goToSystemManagement">
          <div class="card-inner">
            <div class="theme-banner"></div>
            <div class="card-content">
              <div class="entry-title-row">
                <div class="icon-wrapper">
                  <el-icon><Setting /></el-icon>
                </div>
                <span>系统管理</span>
              </div>
              <p class="entry-desc">管理系统全部注册账户，审批VIP权限，查看产品反馈及平台级配置管理，仅管理员可见。</p>
              <div class="action-footer">
                <el-button type="warning" class="enter-btn" @click.stop="goToSystemManagement">
                  进入系统管理 <el-icon class="btn-arrow"><Right /></el-icon>
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { Calendar, DataAnalysis, Setting, Right, Operation, Grid, Clock, Search } from '@element-plus/icons-vue'
import { clearAuth, getUser, isAdmin, isLoggedIn } from '@/utils/auth'
import { authApi } from '@/api'
import { ElMessage } from 'element-plus'

const router = useRouter()
const loggedIn = computed(() => isLoggedIn())
const currentUser = computed(() => getUser())
const isAdminUser = computed(() => isAdmin())

const goToLogin = () => {
  router.push('/login')
}

const goToRegister = () => {
  router.push('/register')
}

const goToClock = () => {
  router.push('/exam-clock')
}

const goToScheduling = () => {
  if (!isLoggedIn()) {
    ElMessage.warning('请先登录后再进入排监考系统')
    router.push('/login')
    return
  }
  router.push('/semesters')
}

const goToAnalysis = () => {
  if (!isLoggedIn()) {
    ElMessage.warning('请先登录后再进入成绩分析系统')
    router.push('/login')
    return
  }
  router.push('/grades')
}

const goToDivision = () => {
  if (!isLoggedIn()) {
    ElMessage.warning('请先登录后再进入智能分班系统')
    router.push('/login')
    return
  }
  router.push('/division')
}

const goToCourseScheduling = () => {
  if (!isLoggedIn()) {
    ElMessage.warning('请先登录后再进入智能排课系统')
    router.push('/login')
    return
  }
  router.push('/course-schedule')
}

const goToScoreQuery = () => {
  if (!isLoggedIn()) {
    ElMessage.warning('请先登录后再进入成绩查询发布')
    router.push('/login')
    return
  }
  router.push('/score-query')
}

const goToSystemManagement = () => {
  if (!isLoggedIn()) {
    ElMessage.warning('请先登录后再进入系统管理')
    router.push('/login')
    return
  }
  if (!isAdmin()) {
    ElMessage.error('仅管理员可进入系统管理')
    return
  }
  router.push('/users')
}

const handleLogout = async () => {
  try {
    await authApi.logout()
  } catch (error) {
    // Ignore logout API errors and clear local session anyway.
  }
  clearAuth()
  router.replace('/login')
}
</script>

<style scoped>
.portal-page {
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 24px;
  background: radial-gradient(circle at 50% 50%, #f3f4f6 0%, #e5e7eb 100%);
  overflow: hidden;
  font-family: 'Outfit', 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

/* Glassmorphism Floating Blobs */
.bg-blob {
  position: absolute;
  border-radius: 50%;
  filter: blur(120px);
  z-index: 1;
  opacity: 0.65;
  animation: float 25s infinite alternate ease-in-out;
}
.blob-indigo {
  width: 450px;
  height: 450px;
  background: radial-gradient(circle, rgba(99, 102, 241, 0.45) 0%, rgba(165, 180, 252, 0.1) 100%);
  top: -10vh;
  left: -5vw;
}
.blob-rose {
  width: 550px;
  height: 550px;
  background: radial-gradient(circle, rgba(244, 63, 94, 0.35) 0%, rgba(253, 164, 175, 0.1) 100%);
  bottom: -15vh;
  right: -5vw;
  animation-delay: -7s;
}
.blob-teal {
  width: 400px;
  height: 400px;
  background: radial-gradient(circle, rgba(20, 184, 166, 0.3) 0%, rgba(153, 246, 228, 0.1) 100%);
  top: 40vh;
  right: 25vw;
  animation-delay: -14s;
}

@keyframes float {
  0% {
    transform: translate(0px, 0px) scale(1);
  }
  50% {
    transform: translate(50px, -80px) scale(1.12);
  }
  100% {
    transform: translate(-30px, 30px) scale(0.92);
  }
}

/* Glass Card Layout */
.portal-card {
  position: relative;
  z-index: 10;
  width: min(1040px, 100%);
  background: rgba(255, 255, 255, 0.82);
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
  border-radius: 28px;
  padding: 48px;
  box-shadow: 
    0 4px 6px -1px rgba(0, 0, 0, 0.03),
    0 20px 40px -4px rgba(0, 0, 0, 0.08),
    inset 0 1px 0 rgba(255, 255, 255, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.6);
}

/* Top bar styles */
.portal-topbar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 28px;
}

.auth-links {
  display: flex;
  gap: 12px;
}
.auth-btn {
  font-weight: 500;
  border-radius: 8px;
}

.user-meta {
  display: flex;
  align-items: center;
  gap: 12px;
  background: rgba(255, 255, 255, 0.5);
  padding: 6px 12px;
  border-radius: 12px;
  border: 1px solid rgba(226, 232, 240, 0.8);
}
.school-tag, .username-tag {
  border-radius: 6px;
  font-weight: 500;
}
.logout-btn {
  border-radius: 6px;
}

/* Header Text styling */
.portal-header {
  text-align: center;
  margin-bottom: 44px;
}
.portal-title {
  font-size: 38px;
  font-weight: 800;
  margin: 0 0 12px 0;
  letter-spacing: -0.5px;
  color: #1e293b;
}
.brand-love {
  background: linear-gradient(135deg, #ff4e50 0%, #f9d423 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 900;
  margin-right: 4px;
  text-shadow: 0 2px 10px rgba(255, 78, 80, 0.15);
}
.brand-sub {
  background: linear-gradient(135deg, #1e293b 0%, #475569 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.portal-subtitle {
  font-size: 16px;
  color: #64748b;
  margin: 0;
}

/* Responsive Grid styling */
.portal-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 24px;
  align-items: stretch;
}

/* Beautiful Interactive Card styling */
.entry-card {
  position: relative;
  background: rgba(255, 255, 255, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.7);
  border-radius: 20px;
  overflow: hidden;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.01), 0 2px 4px -1px rgba(0, 0, 0, 0.01);
}

.card-inner {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.theme-banner {
  height: 6px;
  width: 100%;
  transition: height 0.3s ease;
}

/* Individual themes styling */
.scheduling-theme .theme-banner {
  background: linear-gradient(90deg, #6366f1, #818cf8);
}
.analysis-theme .theme-banner {
  background: linear-gradient(90deg, #10b981, #34d399);
}
.division-theme .theme-banner {
  background: linear-gradient(90deg, #ec4899, #f43f5e);
}
.course-schedule-theme .theme-banner {
  background: linear-gradient(90deg, #8b5cf6, #d946ef);
}
.admin-theme .theme-banner {
  background: linear-gradient(90deg, #f59e0b, #fbbf24);
}
.clock-theme .theme-banner {
  background: linear-gradient(90deg, #ea580c, #fb923c);
}
.score-query-theme .theme-banner {
  background: linear-gradient(90deg, #0ea5e9, #38bdf8);
}

.card-content {
  padding: 28px;
  display: flex;
  flex-direction: column;
  flex: 1;
}

.entry-title-row {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 20px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 16px;
}

.icon-wrapper {
  width: 42px;
  height: 42px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  transition: all 0.3s ease;
}

/* Icons styling by theme */
.scheduling-theme .icon-wrapper {
  background: #f5f3ff;
  color: #6366f1;
}
.analysis-theme .icon-wrapper {
  background: #ecfdf5;
  color: #10b981;
}
.division-theme .icon-wrapper {
  background: #fdf2f8;
  color: #ec4899;
}
.course-schedule-theme .icon-wrapper {
  background: #f5f3ff;
  color: #8b5cf6;
}
.admin-theme .icon-wrapper {
  background: #fffbeb;
  color: #f59e0b;
}
.clock-theme .icon-wrapper {
  background: #fff7ed;
  color: #ea580c;
}

.entry-desc {
  font-size: 14px;
  line-height: 1.6;
  color: #64748b;
  margin: 0 0 24px 0;
  flex: 1;
}

.action-footer {
  margin-top: auto;
}

.enter-btn {
  width: 100%;
  height: 40px;
  font-weight: 600;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border: none;
  transition: all 0.3s ease;
}

.btn-arrow {
  transition: transform 0.3s ease;
}

/* Card Hover Animations */
.entry-card:hover {
  transform: translateY(-6px);
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 
    0 10px 15px -3px rgba(0, 0, 0, 0.04),
    0 20px 25px -5px rgba(0, 0, 0, 0.08);
}

.entry-card:hover .theme-banner {
  height: 10px;
}

.entry-card:hover .btn-arrow {
  transform: translateX(4px);
}

/* Card hover scaling elements */
.scheduling-theme:hover {
  border-color: rgba(99, 102, 241, 0.4);
}
.scheduling-theme:hover .icon-wrapper {
  background: #6366f1;
  color: #ffffff;
}

.analysis-theme:hover {
  border-color: rgba(16, 185, 129, 0.4);
}
.analysis-theme:hover .icon-wrapper {
  background: #10b981;
  color: #ffffff;
}

.division-theme:hover {
  border-color: rgba(236, 72, 153, 0.4);
}
.division-theme:hover .icon-wrapper {
  background: #ec4899;
  color: #ffffff;
}

.course-schedule-theme:hover {
  border-color: rgba(139, 92, 246, 0.4);
}
.course-schedule-theme:hover .icon-wrapper {
  background: #8b5cf6;
  color: #ffffff;
}

.admin-theme:hover {
  border-color: rgba(245, 158, 11, 0.4);
}
.admin-theme:hover .icon-wrapper {
  background: #f59e0b;
  color: #ffffff;
}

.clock-theme:hover {
  border-color: rgba(234, 88, 12, 0.4);
}
.clock-theme:hover .icon-wrapper {
  background: #ea580c;
  color: #ffffff;
}

.score-query-theme .icon-wrapper {
  background: #e0f2fe;
  color: #0ea5e9;
}
.score-query-theme:hover {
  border-color: rgba(14, 165, 233, 0.4);
}
.score-query-theme:hover .icon-wrapper {
  background: #0ea5e9;
  color: #ffffff;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .portal-card {
    padding: 32px 20px;
    border-radius: 20px;
  }
  .portal-title {
    font-size: 30px;
  }
  .portal-grid {
    grid-template-columns: 1fr;
  }
}
</style>
